$(function() {
  /**
   * Dropdown menu in header
   */
  $('header .dropdown')
    .on('hidden.bs.dropdown', function () {
      $(this).find('i.fcml-caret-up').addClass('fcml-caret-down').removeClass('fcml-caret-up');
    })
    .on('shown.bs.dropdown', function () {
        $(this).find('i.fcml-caret-down').addClass('fcml-caret-up').removeClass('fcml-caret-down');
    });

  /**
   * Menu in header for mobile version
   */
  $('.navbar-collapse')
      .on('hidden.bs.collapse', function () {
        $('body').removeClass('overflow-y-hidden');
      })
      .on('shown.bs.collapse', function () {
        $('body').addClass('overflow-y-hidden');
      });
});
